import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  FormControl,
  FormLabel,
  Grid,
  Typography,
  InputAdornment,
  IconButton
} from "@mui/material";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { useFormik } from "formik";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../bmr/components/common/FormikControl";
import HospitalApi from "../../services/hospitalService";
import FormField from "../../../src/bmr/components/styled/FormField";

import { useEffect, useState } from "react";
import {
  addPreScreenForm,
  fetchDetailsPreScreen,
  selectbmrAppointmentLoading,
  uploadFiles,
  deleteFile,
} from "../../bmr/slices/appointment";
import {
  fetchQueryList,
} from "../../bmr/slices/queryPreScreen";
// import TableConverter from "./common-pre-screen/TableConverter";
import {
  BulkyDiseaseOptions,
  getNestedValue,
  getTodayDate,
  MAX_FILE_SIZE,
  PatientsNationalityOptions,
  PreScreenValidationSchema,
  primaryDiagnosisOptions,
  primaryDiagnosisSubtypeOptions,
  PrimaryRefractoryOptions,
  returnPostData,
  SUPPORTED_FORMATS,
  transformDataWithFiles,
} from "./common-pre-screen/common";
import FormikArrayPreScreen from "./common-pre-screen/FormikArrayPreScreen";
import SkeletonLoader from "../../utilites/SkeltonLoader";
import { convertIntoTimeZone, formatDateMoment, formatDateForApi } from "../../utils/utils";
import PreScreenComment from "./common-pre-screen/PreScreenComment";
import PreScreenQueryHistory from "./common-pre-screen/PrescreenQueryHistory";
import {
  CheckGreen,
  DownIcon,
  InfoIcon,
  EditIcon
} from "../../assets/common-svg/CommonSvg";
import DownloadImageApi from "../../services/downloadImageService";
import DeleteModal from "../../bmr/components/common/BaseModal/DeleteModal";
import { notify } from "../../bmr/utils/methods/notification";
import DateRangePickerModal from "../../../src/components/custom-date-range/DateRangePickerModal"
import { updateScheduleApheresis } from "../../bmr/slices/feasibility";
import { setOperationTitle } from "../../store/reducers/operation";

const PreScreenForm = ({ patientData, disabledAll, getSubjectDetails }) => {
  const dispatch = useDispatch();
  const LoginData = useSelector((state) => state.loginData);
  // const userAuthority = LoginData?.auth || [];
  const role_id = LoginData?.role_id;
  const role_slug = LoginData?.role_slug;
  const isEditorPM = role_id === 5 || role_slug === "project-manager" ;
  let secheduleShow = useSelector((state) => state.bmrHelp.storeSechedule);
  const isLoading = useSelector(selectbmrAppointmentLoading);
  const [preScreenForm, setPreScreenForm] = useState({});
  const [checkPreScreenForm, setCheckPreScreenForm] = useState({});
  const [cityList, setCityList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [queriesFields, setQueryFields] = useState([]);
  const [queryData, setQueryData] = useState([]);
  const [selectedField, setSelectedField] = useState(null);
  const [deleteModal, setDeleteModal] = useState(null);
  const [PreScreenFormExpanded, setPreScreenFormExpanded] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  /*****sechedule aphereris**/
    // Add these state variables for date range modal
  const [dateRangeModalOpen, setDateRangeModalOpen] = useState(false);
  const [datePeferredModalOpen, setDatePeferredModalOpen] = useState(false)
  const [isDraft, setIsDraft] = useState(false);
  const resolveQueryUser = ['editor','project-manager']

  // Add this function to format the display date
// Add this function to format the display date
const formatDateRangeDisplay = () => {
  if (!formik?.values?.apheresisDateRange?.startDate || !formik?.values?.apheresisDateRange?.endDate) {
    return "Select Date Range";
  }


const start = formatDateMoment(formik?.values?.apheresisDateRange?.startDate);
const end = formatDateMoment(formik?.values?.apheresisDateRange?.endDate);

// Check invalid case
if (start === 'Invalid Date' || end === 'Invalid Date') {
  return 'Invalid Date Range';
}

return `${start} - ${end}`;
}
  /****************/ 
  const open = Boolean(anchorEl) || false;
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const initialValues = {
    hospital_id: patientData?.investigator?.hospital_details?.id ?? null,
    hospital_code: patientData?.investigator?.hospital_details?.hospital_code ?? null,
    hospital_name: patientData?.investigator?.hospital_details?.name ?? "",
    treating_physician: patientData?.investigator?.id ?? null,
    patient_id: patientData?.id ?? null,
    hospital_patient_id: preScreenForm?.hospital_patient_id ?? null,
    patient_name: patientData?.first_name
      ? `${patientData?.first_name} ${patientData?.last_name}`
      : "",
    patient_initials: patientData?.sub_initials ?? "",
    dob: patientData?.dob ? new Date(patientData?.dob) : "",
    gender: patientData?.gender ?? "",
    patient_age: patientData?.dob
      ? moment().diff(moment(patientData?.dob), "years")
      : "",
    patient_body_weight: preScreenForm?.patient_body_weight ?? "",
    patients_nationality: preScreenForm?.patients_nationality ?? null,
    mention_nationality: preScreenForm?.mention_nationality ?? "",
    state_id: preScreenForm?.state_id ?? null,
    city_id: preScreenForm?.city_id ?? null,

    primary_diagnosis_id: preScreenForm?.primary_diagnosis_id ?? null,
    subtype: preScreenForm?.subtype ?? null,

    cytogenetic_molecular_abnormalities:
      preScreenForm?.cytogenetic_molecular_abnormalities ?? null,
    biopsy_confirmed: preScreenForm?.biopsy_confirmed ?? null,
    cytogenetic_report: preScreenForm?.cytogenetic_report ?? null,

    "biopsy-confirmed-report": preScreenForm?.["biopsy-confirmed-report"] ?? [],
    "karyotyping-report": preScreenForm?.["karyotyping-report"] ?? [],

    date_of_last_relapse_or_refractoriness:
      preScreenForm?.date_of_last_relapse_or_refractoriness ?? "",
    number_of_lines_of_therapies_prior_to_car_t:
      preScreenForm?.number_of_lines_of_therapies_prior_to_car_t ?? null,
    primary_refractory: preScreenForm.primary_refractory ?? null,
    treatment_history: preScreenForm?.treatment_history
      ? JSON.parse(preScreenForm?.treatment_history)
      : [{ treatment_for: "", start_date: "", end_date: "" }],
    last_treatment_regimen: preScreenForm?.last_treatment_regimen ?? "",
    last_treatment_dates: preScreenForm?.last_treatment_dates
      ? JSON.parse(preScreenForm.last_treatment_dates)
      : { start_date: "", stop_date: "" },
    bulky_disease_dlbcl: preScreenForm?.bulky_disease_dlbcl ?? null,
    b_all_blast_percentage: preScreenForm?.b_all_blast_percentage ?? null,
    ecog_ps: preScreenForm?.ecog_ps ?? null,
    lvef_percentage: preScreenForm?.lvef_percentage ?? null,
    baseline_crp_level: preScreenForm?.baseline_crp_level ?? null,
    baseline_ldh_level: preScreenForm?.baseline_ldh_level ?? null,
    baseline_lymphocyte_to_monocyte_ratio: preScreenForm?.baseline_lymphocyte_to_monocyte_ratio ?? null,
    patient_occupation: preScreenForm?.patient_occupation ?? "",
    family_annual_income: preScreenForm?.family_annual_income ?? "",
     ferritin: preScreenForm?.ferritin ?? null,
    alc: preScreenForm?.alc ?? null,
      anc: preScreenForm?.anc ?? null,
     hb: preScreenForm?.hb ?? null,
    // upload files
    "biopsy-report": preScreenForm?.["biopsy-report"] ?? [],
    "flow-cytometry": preScreenForm?.["flow-cytometry"] ?? [],
    "additional-report": preScreenForm?.["additional-report"] ?? [],
    "biopsy-diagnosis-report": preScreenForm?.["biopsy-diagnosis-report"] ?? [],
    "discharge-summary": preScreenForm?.["discharge-summary"] ?? [],
    "cytogenetics-report": preScreenForm?.["cytogenetics-report"] ?? [],
    "histopathology-report": preScreenForm?.["histopathology-report"] ?? [],
    "histopathology-diagnosis-report": preScreenForm?.["histopathology-diagnosis-report"] ?? [],
    "ihc-report": preScreenForm?.["ihc-report"] ?? [],
    "pet-scan": preScreenForm?.["pet-scan"] ?? [],
    "csf-report": preScreenForm?.["csf-report"] ?? [],
    "bcrabl-report": preScreenForm?.["bcrabl-report"] ?? [],
    "bone-marrow-involvement": preScreenForm?.["bone-marrow-involvement"] ?? [],
    "chimerism-report": preScreenForm?.["chimerism-report"] ?? [],
    "preferred_date": preScreenForm?.["preferred_date"] ?? [],
    "serum-immunoglobulin":  preScreenForm?.["serum-immunoglobulin"] ?? [],
    "cbc-report":  preScreenForm?.["cbc-report"] ?? [],
    "biochemistry-report":  preScreenForm?.["biochemistry-report"] ?? [],
    "serology":  preScreenForm?.["serology"] ?? [],
     'pet-ct-report':preScreenForm?.["pet-ct-report"] ?? [],
    "apheresisDateRange": preScreenForm?.["apheresis_from_date"] ? {
        startDate: preScreenForm?.["apheresis_from_date"],
        endDate: preScreenForm?.["apheresis_to_date"],
      } : {} 
      /* "apheresisDateRange": {
        startDate: '12/11/2025',
        endDate: '14/11/2025',
      } */
  };
  const getState = () =>
    HospitalApi.getAllState().then((res) => {
      setStateList(
        res?.data?.states?.map((op) => {
          return { value: op.id, label: op.name };
        })
      );
    });

  const getCity = (state_id) => {
    if (state_id) {
      HospitalApi.getCityByState(state_id).then((res) => {
        setCityList(
          res?.data?.cities?.map((op) => {
            return { value: op.id, label: op.name };
          })
        );
      });
    }
  };

  const getPrimaryDiagnosis = async () => {
    const preScreenId = patientData?.prescreen_form?.id;
    const res = await dispatch(fetchDetailsPreScreen(preScreenId));
    if (res?.payload?.status == 200) {
      let data = transformDataWithFiles(res.payload.data);
      setPreScreenForm(data);
      setCheckPreScreenForm(data);
      setQueryFields(data.queries);
    }
  };

  useEffect(() => {
    getState();
    getPrimaryDiagnosis();
  }, [patientData?.prescreen_form?.id]);

  const handleDownload = async (id) => {
    try {
      const imgRes = await DownloadImageApi.getDownloadedImageul(id);
      const response = await fetch(imgRes?.data || "");

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      return response?.url;
    } catch (error) {
      // console.error("Download failed:", error);
     notify.error("Download failed. Please try again later.");
    }
  };
  const handleSubmit = async (values) => {
   if(secheduleShow){
      const data = {
            id: patientData?.feasibility_assessments?.id,
            apheresis_from_date:formatDateForApi(
              values?.apheresisDateRange?.startDate),
            apheresis_to_date: formatDateForApi(
              values?.apheresisDateRange?.endDate),
            preferred_date:  values.preferred_date
          };
    
          const scheduleApheresis = await dispatch(
            updateScheduleApheresis(data)
          ).unwrap();
          if(scheduleApheresis.status){
          notify.success(scheduleApheresis.message)
          dispatch(setOperationTitle(null));
           getSubjectDetails();
           setPreScreenFormExpanded(false);
          }else{
          notify.error(scheduleApheresis.message)
          }
        }else{
           const data  = {
          ...values,
             requested_apheresis_to_date: formatDateForApi(values?.apheresisDateRange?.endDate),
            requested_apheresis_from_date: formatDateForApi(values?.apheresisDateRange?.startDate),
           }
    const result = returnPostData(data);
    await dispatch(
      addPreScreenForm({
        data: {
          ...result,
          preferable_leukapheresis_dates: JSON.stringify(
            result.preferable_leukapheresis_dates
          ),
          apheresis_from_date:formatDateForApi(
              result?.apheresisDateRange?.startDate),
          apheresis_to_date:formatDateForApi(
              result?.apheresisDateRange?.endDate),
          treatment_history: JSON.stringify(result.treatment_history),
          last_treatment_dates: (result.last_treatment_dates?.start_date || result.last_treatment_dates?.stop_date) ? JSON.stringify(result.last_treatment_dates):null,
          is_draft : isDraft ? 1 : 0,
          status: isDraft ? 'draft' : 'submit',
          patient_body_weight: result?.patient_body_weight ?? null,
          cytogenetic_report: result?.cytogenetic_report  ?? null,
          bulky_disease_dlbcl: result?.bulky_disease_dlbcl ? result?.bulky_disease_dlbcl : null,
          biopsy_confirmed:  result?.biopsy_confirmed ?? null,
          ferritin: result?.ferritin ?? null,
          alc:result?.alc ?? null,
          anc:result?.anc ?? null,
          hb: result?.hb ?? null,
          ...preScreenForm?.id ? {prescrening_id: preScreenForm?.id}:{}
        },
      })
    );
     getSubjectDetails();
    setPreScreenFormExpanded(false);
  }
    // resetForm(); // Reset form after successful submission
  };

  const formik = useFormik({
    initialValues,
    validateOnBlur: false,
    validationSchema: PreScreenValidationSchema(isDraft),
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    getCity(formik?.values?.state_id);
  }, [formik?.values?.state_id]);
  
  const handleUploadFiles = async (e) => {
    const { name, files } = e.target;
    const AllFiles = Array.from(files);
    if (AllFiles?.length != 0) {
      const validFiles = AllFiles.filter(
        (file) =>
          SUPPORTED_FORMATS.includes(file.type || file.file_type) &&
          (file.size <= MAX_FILE_SIZE || file.file_size <= MAX_FILE_SIZE)
      );

      if (files.length > 0 && validFiles.length === 0) {
        formik.setFieldError(
          name,
          "Files must be supported format and under 25MB"
        );
        return;
      }

      const formData = new FormData();
      validFiles.forEach((file) => {
        formData.append(name, file);
      });
      const res = await dispatch(
        uploadFiles({ data: formData, id: patientData?.id })
      );
      if (res?.payload?.data) {
        const fileValues = formik?.values[name];
        const existingFiles = fileValues || [];
        formik.setFieldValue(name, [...existingFiles, ...res.payload.data]);
      }
    }
  };

  const hanldeRemoveFiles = async () => {
    const res = await dispatch(deleteFile(deleteModal?.id));
    if (res?.payload?.status === 200) {
      const currentFiles = formik?.values[deleteModal?.name] || [];
      const updatedFiles = currentFiles.filter(
        (file) => file.id !== deleteModal?.id
      );
      formik.setFieldValue(deleteModal?.name, updatedFiles);
    }
    setDeleteModal(null);
  };

  // Menu handlers
  const handleQuestionClick = async (event, formProps) => {
    const { name, type, label, options } = formProps;
    const query = queriesFields?.find((op) => op.fields == name);
    const element = event.currentTarget;
    const res = await dispatch(fetchQueryList(query?.field_id));
    if (res?.payload?.status == 200) {
      setQueryData(res?.payload?.data);
    } else {
      setQueryData([]);
    }

    const value =
      type == "select" || type == "radio"
        ? options?.find((op) => op.value == formik?.values[name])?.label
        : getNestedValue(formik?.values, name);

    setSelectedField({
      ...query,
      is_file: type == "file" ? true : false,
      field_label: label,
      field_name: name,
      isResolve:formProps?.isResolve,
      prescreening_id: patientData?.prescreen_form?.id,
      patient_id: patientData?.id,
      field_value: value,
    });
    setAnchorEl(element);
  };

      // Add this function to handle date range selection
  const handleDateRangeApply = (range) => {
    // You can also set the formik value if needed
    formik.setFieldValue('preferred_date', range?.selectedDates);
    formik.setFieldValue('apheresisDateRange', {
        startDate: range.startDate,
        endDate: range.endDate
      });
  };

  const handleManualFormikValidaction = async () => {
    const errors = await formik.validateForm();

    if (Object.keys(errors).length > 0) {
      formik.setErrors(errors);

      const touchedFields = Object.keys(errors).reduce((acc, key) => {
        acc[key] = true;
        return acc;
      }, {});
      formik.setTouched(touchedFields);
      const errorList = Object.keys(errors)?.map((key, index) => `${index + 1}. ${key}`)
        .join("\n");
     notify.error(`Following mandatory field(s) required:\n${errorList}`)
      return 0;
    } else {
      return 1;
    }
  };

  const formOptions = [
    { section: "A . Hospital & Patient Demographics" },
    {
      label: "Hospital Id",
      type: "text",
      noQuery: true,
      disabled: true,
      required: true,
      name: "hospital_code",
      placeholder: "Enter hospital case number",
      col: 2,
    },
    {
      label: "Hospital Name",
      type: "text",
      name: "hospital_name",
      disabled: true,
      noQuery: true,
      required: true,
      col: 2,
    },
    {
      label: "Treating Physician",
      type: "select",
      options: [
        {
          value: patientData?.investigator?.id,
          label: patientData?.investigator?.name,
        },
      ],
      name: "treating_physician",
      disabled: true,
      noQuery: true,
      required: true,
      col: 2,
    },
    {
      label: "Patient Full Name",
      type: "text",
      name: "patient_name",
      required: true,
      noQuery: true,
      disabled: true,
      placeholder: "Enter Text",
      col: 2,
    },
    {
      label: "Patient Initials",
      type: "text",
      name: "patient_initials",
      disabled: true,
      noQuery: true,
      required: true,
      placeholder: "Enter Text",
      col: 2,
    },
    {
      label: "Date of Birth",
      // subLabel: "Enter number in years only",
      type: "date",
      disabled: true,
      noQuery: true,
      required: true,
      name: "dob",
      placeholder: "Enter Text",
      col: 2,
    },
    {
      label: "Age (Years)",
      // subLabel: "Enter number in years only",
      type: "text",
      disabled: true,
      noQuery: true,
      required: true,
      name: "patient_age",
      placeholder: "Enter Text",
      col: 2,
    },
    {
      label: "Patient Gender",
      type: "text",
      disabled: true,
      noQuery: true,
      name: "gender",
      required: true,
      placeholder: "Enter patient gender",
      col: 2,
    },
    
    {
      label: "Hospital Given Patient ID",
      type: "text",
      name: "hospital_patient_id",
      disabled: disabledAll,
      isResolve: resolveQueryUser,
      placeholder:"Enter hospital given patient id",
      required: true,
      col: 2,
    },
    {
      label: "Patient Weight (Kg)",
      type: "number",
      disabled: disabledAll,
      required: true,
       isResolve: resolveQueryUser,
      name: "patient_body_weight",
      placeholder: "Enter patient's body weight",
      col: 2,
    },
    {
      label: "Patients Nationality",
      type: "radio",
      name: "patients_nationality",
      required: true,
      disabled: disabledAll,
      isResolve: resolveQueryUser,
      options: PatientsNationalityOptions,
      col: 2,
    },
    {
      label: "State",
      type: "select",
      name: "state_id",
      required: true,
       isResolve: resolveQueryUser,
      disabled: disabledAll,
      options: stateList,
      placeholder: "Select state",
      depend: "patients_nationality",
      dependValue: "Indian",
      col: 2,
    },
    {
      label: "City",
      type: "select",
      name: "city_id",
      disabled: disabledAll,
      required: true,
      isResolve: resolveQueryUser,
      placeholder: "Select city",
      options: cityList,
      depend: "patients_nationality",
      dependValue: "Indian",
      col: 2,
    },
    {
      // label: 'State',
      type: "text",
      name: "mention_nationality",
      required: true,
       isResolve: resolveQueryUser,
      disabled: disabledAll,
      options: stateList,
      placeholder: "Enter Nationality",
      depend: "patients_nationality",
      dependValue: "International",
    },
    // {
    //     label: "Please Mention Nationality",
    //     type: 'text',
    //     disabled: disabledAll,
    //     name: 'please_mention_nationality',
    //     placeholder: 'Enter please mention nationality'
    // },
    { section: "B . Clinical Diagnosis & History" },
    {
      label: "Primary Diagnosis",
      type: "select",
      disabled: disabledAll,
      isResolve: resolveQueryUser,
      name: "primary_diagnosis_id",
      placeholder: "Select the primary diagnosis",
      required: true,
      options: primaryDiagnosisOptions,
    },
    {
      label: "Subtype",
      type: "select",
      disabled: disabledAll,
      name: "subtype",
      placeholder: "Select subtype",
      required: false,
       isResolve: resolveQueryUser,
      options: primaryDiagnosisSubtypeOptions,
      depend: "primary_diagnosis_id",
      dependValue: "2",
    },
    {
      label: "Cytogenetic / Molecular Abnormalities",
      type: "textarea",
      required: false,
       isResolve: resolveQueryUser,
      disabled: disabledAll,
      name: "cytogenetic_molecular_abnormalities",
      placeholder: "Enter Cytogenetic / Molecular Abnormalities",
    },
    {
      label: "Biopsy Confirmed",
      type: "radio",
      disabled: disabledAll,
      options: PrimaryRefractoryOptions,
      required: true,
       isResolve: resolveQueryUser,
      name: "biopsy_confirmed",
      placeholder: "Enter any olecular markers",
      col: 2,
    },
    {
      label: "Cytogenetic Report Available",
      type: "radio",
      disabled: disabledAll,
       isResolve: resolveQueryUser,
      options: PrimaryRefractoryOptions,
      name: "cytogenetic_report",
      required: true,
      placeholder: "Enter any olecular markers",
      col: 2,
    },
    {
      label: "Biopsy Report",
      type: "file",
      disabled: disabledAll,
      removeButton: role_id == 5 || role_slug === "project-manager",
      onChange: handleUploadFiles,
      removeFile: (name, id) => {
        setDeleteModal({ name: name, id: id });
      },
      downloadFile: handleDownload,
      multiple: true,
      name: "biopsy-confirmed-report",
      acceptFormat: SUPPORTED_FORMATS,
      required: true,
      placeholder: "Enter any olecular markers",
      depend: "biopsy_confirmed",
      dependValue: "1",
       isResolve: resolveQueryUser,
    },
    {
      label: "Cytogenetic/Karyotyping Report",
      type: "file",
      disabled: disabledAll,
      removeButton: isEditorPM,
      name: "karyotyping-report",
      onChange: handleUploadFiles,
      removeFile: (name, id) => {
        setDeleteModal({ name: name, id: id });
      },
      downloadFile: handleDownload,
      acceptFormat: SUPPORTED_FORMATS,
      multiple: true,
      required: true,
      isResolve: resolveQueryUser,
      placeholder: "Enter any olecular markers",
      depend: "cytogenetic_report",
      dependValue: "1",
    },
    { section: "C . Disease & Treatment Timeline" },
    {
      label: "Date of last Relapse/Refractoriness",
      type: "date",
      required: true,
      disabled: disabledAll,
      max: new Date(),
      // format: "DD/MMM/YYYY",
      inputClassName: "!py-[13px] !px-[13px]",
      name: "date_of_last_relapse_or_refractoriness",
      placeholder: "Select Date ",
       isResolve: resolveQueryUser,
      col: 2,
    },
    {
      label: "Number of Prior Lines of Therapy",
      type: "number",
      name: "number_of_lines_of_therapies_prior_to_car_t",
      required: true,
      disabled: disabledAll,
       isResolve: resolveQueryUser,
      placeholder: "Enter Number of Prior Lines of Therapy",
      col: 2,
    },
    {
      label: "Primary Refractory",
      type: "radio",
      required: true,
      name: "primary_refractory",
      disabled: disabledAll,
       isResolve: resolveQueryUser,
      options: PrimaryRefractoryOptions,
      col: 2,
    },
    {
      label: "Treatment History",
      subLabel:
        "(for each line of treatment, preferably mention Start date and / or Stop Date (dd/mm/yyyy)",
      type: "textarea",
      name: "treatment_history",
      required: true,
      disabled: disabledAll,
      manualValues: true,
       isResolve: resolveQueryUser,
      initialChildrenData: { treatment_for: "", start_date: "", end_date: "" },
      multipleField: true,
      col: 3,
      children: (index) => [
        {
          label: "Drug(s)",
          type: "text",
          name: `treatment_history.${index}.treatment_for`,
          required: true,
          disabled: disabledAll,
          placeholder: "Enter Drug(s)",
           isResolve: resolveQueryUser,
          manualError: true,
        },
        {
          label: "Start Date",
          inputClassName: "!py-[13px] !px-[13px]",
          type: "date",
          disabled: disabledAll,
           isResolve: resolveQueryUser,
          name: `treatment_history.${index}.start_date`,
          max:
            formik?.values?.treatment_history[index]?.end_date &&
              convertIntoTimeZone(
                formik?.values?.treatment_history[index]?.end_date
              )
              ? convertIntoTimeZone(
                formik?.values?.treatment_history[index]?.end_date
              )
              : getTodayDate(),
          required: true,
          placeholder: "Select start date",
          manualError: true,
        },
        {
          label: "End Date",
          inputClassName: "!py-[13px] !px-[13px]",
          type: "date",
           isResolve: resolveQueryUser,
          disabled: disabledAll,
          name: `treatment_history.${index}.end_date`,
          min:
            formik?.values?.treatment_history[index]?.start_date &&
            convertIntoTimeZone(
              formik?.values?.treatment_history[index]?.start_date
            ),
          max: getTodayDate(),
          required: true,
          placeholder: "Select end date",
          manualError: true,
        },
      ],
    },
    {
      label: "Last Treatment Regimen",
      type: "textarea",
      disabled: disabledAll,
      required: true,
       isResolve: resolveQueryUser,
      name: "last_treatment_regimen",
      placeholder: "Enter last treatment regimen",
    },
    {
      label: "Last Regimen Start/Stop Dates",
      type: "text",
      required: false,
       isResolve: resolveQueryUser,
      name: "last_treatment_dates",
      disabled: disabledAll,
      // manualValues: true,
      multipleField: false,
      isObj: true,
      col: 2,
      children: [
        {
          label: "Start Date",
          inputClassName: "!py-[13px] !px-[13px]",
          type: "date",
           isResolve: resolveQueryUser,
          name: `last_treatment_dates.start_date`,
          required: false,
          disabled: disabledAll,
          placeholder: "Select start date",
          max:
            formik?.values?.last_treatment_dates?.stop_date &&
              convertIntoTimeZone(formik?.values?.last_treatment_dates?.stop_date)
              ? convertIntoTimeZone(
                formik?.values?.last_treatment_dates?.stop_date
              )
              : getTodayDate(),
          manualError: true,
        },
        {
          label: "Stop Date",
          inputClassName: "!py-[13px] !px-[13px]",
          type: "date",
           isResolve: resolveQueryUser,
          disabled: disabledAll,
          name: `last_treatment_dates.stop_date`,
          min: convertIntoTimeZone(
            formik?.values?.last_treatment_dates?.start_date
          ),
          max: new Date(),
          // min: new Date(),
          required: false,
          placeholder: "Select stop date",
          manualError: true,
        },
      ],
    },
    { section: "D . Disease Status & Clinical Indicators" },
    {
      label: "Bulky disease (DLBCL)",
      // subLabel: "Insert 'NA' if 5 not applicable",
      type: "select",
      options: BulkyDiseaseOptions,
      required: false,
      disabled: disabledAll,
      name: "bulky_disease_dlbcl",
      col: 2,
      placeholder: "Enter bulky disease - DLBCL",
      depend: "primary_diagnosis_id",
       isResolve: resolveQueryUser,
      dependValue: "1,2",
    },
    {
      label: "Bulky disease - B-ALL (Blast %)",
      // subLabel: "Insert 'NA' if not applicable",
      type: "text",
      disabled: disabledAll,
       isResolve: resolveQueryUser,
      // inputClassName: "dark-placeholder",
      required: false,
      name: "b_all_blast_percentage",
      // placeholder: 'Enter bulky disease - B-ALL'
      placeholder: "Enter Bulky disease - B-ALL",
      col: 2,
      depend: "primary_diagnosis_id",
      dependValue: "1",
    },
    {
      label: "ECOG Performance Score",
      // subLabel: "Insert number between 0 and 4",
      type: "select",
      disabled: disabledAll,
       isResolve: resolveQueryUser,
      required: true,
      name: "ecog_ps",
      placeholder: "Select ECOG PS",
      options: [
        { value: "0", label: "0" },
        { value: "1", label: "1" },
        { value: "2", label: "2" },
        { value: "3", label: "3" },
        { value: "4", label: "4" },
      ],
      col: 2,
    },
    {
      label: "LVEF %",
      type: "number",
      required: true,
      isResolve: resolveQueryUser,
      disabled: disabledAll,
      name: "lvef_percentage",
      placeholder: "Enter LVEF",
      col: 2,
    },
    {
      label: "Baseline CRP",
      type: "number",
      required: true,
       isResolve: resolveQueryUser,
      disabled: disabledAll,
      subLable:"mg/L",
      name: "baseline_crp_level",
      placeholder: "Enter Baseline CRP",
      col: 2,
    },
    {
      label: "Baseline LDH",
      type: "number",
      required: true,
       isResolve: resolveQueryUser,
      subLable:"U/L",
      disabled: disabledAll,
      name: "baseline_ldh_level",
      placeholder: "Enter Baseline LDH",
      col: 2,
    },
    {
      label: "HB",
      type: "number",
      required: false,
       isResolve: resolveQueryUser,
      disabled: disabledAll,
      subLable:"gm/dl",
      name: "hb",
      placeholder: "Enter HB",
      col: 2,
    },
     {
      label: "ANC",
      type: "number",
      required: false,
       isResolve: resolveQueryUser,
      disabled: disabledAll,
      subLable:"cell/uL",
      name: "anc",
      placeholder: "Enter ANC",
      col: 2,
    },
     {
      label: "ALC",
      type: "number",
      required: false,
       isResolve: resolveQueryUser,
      disabled: disabledAll,
      subLable:"cell/uL",
      name: "alc",
      placeholder: "Enter ALC",
      col: 2,
    },
     {
      label: "Ferritin",
      type: "number",
      required: false,
       isResolve: resolveQueryUser,
      disabled: disabledAll,
      subLable:"ng/ml",
      name: "ferritin",
      placeholder: "Enter Ferritin",
      col: 2,
    },
    {
      label: "Lymphocyte: Monocyte Ratio",
      type: "text",
      required: false,
      disabled: disabledAll,
       isResolve: resolveQueryUser,
      name: "baseline_lymphocyte_to_monocyte_ratio",
      placeholder: "Enter Lymphocyte: Monocyte Ratio",
      col: 2,
    },
    { section: "E . Socioeconomic & Consent Info" },
    {
      label: "Patient's Occupation",
      type: "text",
      disabled: disabledAll,
       isResolve: resolveQueryUser,
      name: "patient_occupation",
      placeholder: "Enter patient's occupation",
      col: 2,
    },
    {
      label: "Family's Annual Income (INR)",
      type: "text",
       isResolve: resolveQueryUser,
      disabled: disabledAll,
      name: "family_annual_income",
      placeholder: "Enter family's annual income",
      col: 2,
    },
    {
      section: "F . Clinical Report Upload Section",
      depend: "primary_diagnosis_id",
      dependValue: "0,1,2",
    },
    {
      label: "Latest Bone Marrow Aspiration & Biopsy Report",
      type: "file",
      required: true,
      disabled: disabledAll,
      removeButton: isEditorPM,
      onChange: handleUploadFiles,
      removeFile: (name, id) => {
        setDeleteModal({ name: name, id: id });
      },
      downloadFile: handleDownload,
      acceptFormat: SUPPORTED_FORMATS,
      name: "biopsy-report",
      multiple: true,
       isResolve: resolveQueryUser,
      placeholder: "Enter any olecular markers",
      depend: "primary_diagnosis_id",
      dependValue: "1",
      col: 2,
    },
    {
      label: "Latest MRD/Flow Cytometry Report",
      type: "file",
      onChange: handleUploadFiles,
      removeFile: (name, id) => {
        setDeleteModal({ name: name, id: id });
      },
      downloadFile: handleDownload,
      required: true,
      disabled: disabledAll,
      removeButton: isEditorPM,
      name: "flow-cytometry",
      acceptFormat: SUPPORTED_FORMATS,
      multiple: true,
      placeholder: "Enter any olecular markers",
      depend: "primary_diagnosis_id",
      dependValue: "1",
       isResolve: resolveQueryUser,
      col: 2,
    },
     {
      label: "Bone Marrow Aspiration & Biopsy Report at Diagnosis",
      type: "file",
      required: false,
       isResolve: resolveQueryUser,
      disabled: disabledAll,
      removeButton: (role_id == 5 || role_slug === "project-manager"),
      onChange: handleUploadFiles,
      removeFile: (name, id) => {
        setDeleteModal({ name: name, id: id });
      },
      downloadFile: handleDownload,
      acceptFormat: SUPPORTED_FORMATS,
      name: "biopsy-diagnosis-report",
      multiple: true,
      placeholder: "Enter biopsy report at diagnosis",
      depend: "primary_diagnosis_id",
      dependValue: "1",
      col: 2,
    },
    {
      label: "Biopsy with IHC Report",
      type: "file",
      required: false,
      onChange: handleUploadFiles,
      removeFile: (name, id) => {
        setDeleteModal({ name: name, id: id });
      },
      downloadFile: handleDownload,
      disabled: disabledAll,
      removeButton: isEditorPM,
      name: "ihc-report",
      acceptFormat: SUPPORTED_FORMATS,
      multiple: true,
      placeholder: "Enter any olecular markers",
      depend: "primary_diagnosis_id",
      dependValue: "1,2",
       isResolve: resolveQueryUser,
      col: 2,
    },
    {
      label: "PET CT (if Extra-medullary disease)",
      type: "file",
      onChange: handleUploadFiles,
      removeFile: (name, id) => {
        setDeleteModal({ name: name, id: id });
      },
      downloadFile: handleDownload,
      required: false,
      disabled: disabledAll,
      removeButton: (role_id == 5 || role_slug === "project-manager"),
      name: "pet-scan",
      multiple: true,
       isResolve: resolveQueryUser,
      acceptFormat: SUPPORTED_FORMATS,
      placeholder: "Enter any olecular markers",
      depend: "primary_diagnosis_id",
      dependValue: "1,2",
      col: 2,
    },
     {
      label: "Latest PET CT Report",
      type: "file",
      onChange: handleUploadFiles,
      removeFile: (name, id) => {
        setDeleteModal({ name: name, id: id });
      },
      downloadFile: handleDownload,
      required: true,
      disabled: disabledAll,
      removeButton: isEditorPM,
      name: "pet-ct-report",
      multiple: true,
      acceptFormat: SUPPORTED_FORMATS,
      placeholder: "Enter pet CT report",
      depend: "primary_diagnosis_id",
      dependValue: "2",
      col: 2,
       isResolve: resolveQueryUser,
    },
    {
      label: "Treatment Summary till date on Hospital Letterhead",
      type: "file",
      onChange: handleUploadFiles,
      removeFile: (name, id) => {
        setDeleteModal({ name: name, id: id });
      },
      downloadFile: handleDownload,
      required: true,
      disabled: disabledAll,
      removeButton:( role_id == 5 || role_slug === "project-manager"),
      name: "discharge-summary",
      multiple: true,
      acceptFormat: SUPPORTED_FORMATS,
      placeholder: "Enter any olecular markers",
      depend: "primary_diagnosis_id",
      dependValue: "1,2,3",
      col: 2,
       isResolve: resolveQueryUser,
    },
    {
      label: "FISH / NGS / Cytogenetics",
      type: "file",
      required: false,
      onChange: handleUploadFiles,
      removeFile: (name, id) => {
        setDeleteModal({ name: name, id: id });
      },
      downloadFile: handleDownload,
      disabled: disabledAll,
      removeButton: isEditorPM,
      name: "cytogenetics-report",
      multiple: true,
      acceptFormat: SUPPORTED_FORMATS,
      placeholder: "Enter any olecular markers",
      depend: "primary_diagnosis_id",
      dependValue: "1,2",
      col: 2,
       isResolve: resolveQueryUser,
    },
     {
      label: "Latest Histopathology report with IHC report",
      type: "file",
      onChange: handleUploadFiles,
      removeFile: (name, id) => {
        setDeleteModal({ name: name, id: id });
      },
      downloadFile: handleDownload,
      required: true,
      disabled: disabledAll,
      removeButton: (role_id == 5 || role_slug === "project-manager"),
      name: "histopathology-report",
      multiple: true,
      acceptFormat: SUPPORTED_FORMATS,
      placeholder: "Enter Histopathology report",
      depend: "primary_diagnosis_id",
      dependValue: "2",
      col: 2,
       isResolve: resolveQueryUser,
    },
    { section: "G . Conditional Uploads Files" },
    {
      label: "CSF / Neuro-imaging (if CNS disease)",
      type: "file",
      onChange: handleUploadFiles,
      removeFile: (name, id) => {
        setDeleteModal({ name: name, id: id });
      },
      downloadFile: handleDownload,
      acceptFormat: SUPPORTED_FORMATS,
      disabled: disabledAll,
      removeButton:( role_id == 5 || role_slug === "project-manager"),
      name: "csf-report",
      multiple: true,
      placeholder: "CSF / Neuro-imaging ",
      depend: "primary_diagnosis_id",
      dependValue: "1,2",
      col: 2,
       isResolve: resolveQueryUser,
    },
    {
      label: "Ph+ve ALL",
      type: "file",
      onChange: handleUploadFiles,
      removeFile: (name, id) => {
        setDeleteModal({ name: name, id: id });
      },
      downloadFile: handleDownload,
      // required: true,
      disabled: disabledAll,
      removeButton: isEditorPM,
      acceptFormat: SUPPORTED_FORMATS,
      name: "bcrabl-report",
      multiple: true,
      placeholder: "RQ-PCR BCR-ABL Report",
      col: 2,
       isResolve: resolveQueryUser,
    },
    {
      label: "Bone marrow aspiration and biopsy (if marrow involvement)",
      type: "file",
      onChange: handleUploadFiles,
      removeFile: (name, id) => {
        setDeleteModal({ name: name, id: id });
      },
      downloadFile: handleDownload,
      // required: true,
      acceptFormat: SUPPORTED_FORMATS,
      disabled: disabledAll,
      removeButton: isEditorPM,
      name: "bone-marrow-involvement",
      multiple: true,
      placeholder: "Bone marrow aspiration and biopsy",
      depend: "primary_diagnosis_id",
      dependValue: "1,2",
      col: 2,
       isResolve: resolveQueryUser,
    },
    
    {
      label: "Chimerism Report (if post transplant)",
      type: "file",
      onChange: handleUploadFiles,
      removeFile: (name, id) => {
        setDeleteModal({ name: name, id: id });
      },
      downloadFile: handleDownload,
      // required: true,
      acceptFormat: SUPPORTED_FORMATS,
      disabled: disabledAll,
      removeButton: isEditorPM,
      name: "chimerism-report",
      multiple: true,
      placeholder: "Chimerism Report",
      depend: "primary_diagnosis_id",
      dependValue: "1,2",
      col: 2,
       isResolve: resolveQueryUser,
    },
    {
      label: "Serum Immunoglobulin Levels",
      type: "file",
      onChange: handleUploadFiles,
      removeFile: (name, id) => {
        setDeleteModal({ name: name, id: id });
      },
      downloadFile: handleDownload,
      // required: true,
      acceptFormat: SUPPORTED_FORMATS,
      disabled: disabledAll,
      removeButton: (role_id == 5 || role_slug === "project-manager"),
      name: "serum-immunoglobulin",
      multiple: true,
      placeholder: "Serum Immunoglobulin Levels",
      depend: "primary_diagnosis_id",
      dependValue: "1,2",
      col: 2,
       isResolve: resolveQueryUser,
    },
      {
      label: "Histopathology report with IHC report at diagnosis",
      type: "file",
      onChange: handleUploadFiles,
      removeFile: (name, id) => {
        setDeleteModal({ name: name, id: id });
      },
      downloadFile: handleDownload,
      required: false,
      disabled: disabledAll,
      removeButton: (role_id == 5 || role_slug === "project-manager"),
      name: "histopathology-diagnosis-report",
      multiple: true,
      acceptFormat: SUPPORTED_FORMATS,
      placeholder: "Enter Histopathology report at diagnosis",
      depend: "primary_diagnosis_id",
      dependValue: "2",
      col: 2,
       isResolve: resolveQueryUser,
    },
    {
      label: "Latest CBC Report",
      type: "file",
      onChange: handleUploadFiles,
      removeFile: (name, id) => {
        setDeleteModal({ name: name, id: id });
      },
      downloadFile: handleDownload,
      // required: true,
      acceptFormat: SUPPORTED_FORMATS,
      disabled: disabledAll,
      removeButton: (role_id == 5 || role_slug === "project-manager"),
      name: "cbc-report",
      multiple: true,
      placeholder: "Latest CBC Report",
      depend: "primary_diagnosis_id",
      dependValue: "1,2",
      col: 2,
       isResolve: resolveQueryUser,
    },
    {
      label: "Latest Biochemistry Reports (LFT/RFT)",
      type: "file",
      onChange: handleUploadFiles,
      removeFile: (name, id) => {
        setDeleteModal({ name: name, id: id });
      },
      downloadFile: handleDownload,
      // required: true,
      acceptFormat: SUPPORTED_FORMATS,
      disabled: disabledAll,
      removeButton: (role_id == 5 || role_slug === "project-manager"),
      name: "biochemistry-report",
      multiple: true,
      placeholder: "Latest Biochemistry Reports",
      depend: "primary_diagnosis_id",
      dependValue: "1,2",
      col: 2,
      isResolve: resolveQueryUser,
    },
     {
      label: "Serology Reports(HIV/ HCV/HBV/CMV)",
      type: "file",
      onChange: handleUploadFiles,
      removeFile: (name, id) => {
        setDeleteModal({ name: name, id: id });
      },
      downloadFile: handleDownload,
      // required: true,
      acceptFormat: SUPPORTED_FORMATS,
      disabled: disabledAll,
      removeButton: (role_id == 5 || role_slug === "project-manager"),
      name: "serology",
      multiple: true,
      placeholder: "Latest Serology Reports",
      depend: "primary_diagnosis_id",
      dependValue: "1,2",
      col: 2,
       isResolve: resolveQueryUser,
    },
       {
      label: "Any Additional reports",
      type: "file",
      onChange: handleUploadFiles,
      removeFile: (name, id) => {
        setDeleteModal({ name: name, id: id });
      },
      downloadFile: handleDownload,
      // required: true,
      acceptFormat: SUPPORTED_FORMATS,
      disabled: disabledAll,
      removeButton: (role_id == 5 || role_slug === "project-manager"),
      name: "additional-report",
      multiple: true,
      placeholder: "Any Additional reports",
      depend: "primary_diagnosis_id",
      dependValue: "1,2",
      col: 2,
       isResolve: resolveQueryUser,
    },
    { section: "H. Scheduled Apheresis" },
     {
      type: "custom-date-range",
      name: "apheresisDateRange",
      label: "Date Range",
      placeholder: "Select Date Range",
      min: moment().startOf("day").toDate(),
      max: moment().add(1, "year").endOf("day").toDate(),
      required: true,
      disabled: !secheduleShow && disabledAll,
      displayValue: formatDateRangeDisplay(),
      onOpenModal: () => setDateRangeModalOpen(true),
      noQuery: true,
      col:1
    },
  ];
  return (
    <Accordion
      className="w-100  pt-2  !rounded-lg"
      sx={{
        borderLeft: `4px solid ${!disabledAll ||
            queriesFields?.filter((op) => op.resolve == 0)?.length > 0
            ? "#FB9D2C"
            : "#00B278"
          }`,
      }}
      expanded={PreScreenFormExpanded} // <-- make it controlled
      onChange={() => setPreScreenFormExpanded((prev) => !prev)} // <-- toggle manually
    >
      <AccordionSummary
        expandIcon={
          <div className="d-flex gap-3 align-items-center">
            <DownIcon />
          </div>
        }
        aria-controls="panel1-content"
        id="panel1-header"
      >
        {isLoading ? (
          <div>
            <SkeletonLoader
              rowCount={1}
              height={30}
              width={200}
              isTable={false}
            />
            <div className="flex gap-2">
              <SkeletonLoader
                rowCount={2}
                height={30}
                width={140}
                isTable={false}
              />
            </div>
          </div>
        ) : (
          <Typography className="flex flex-col gap-2 ">
            <span className="font-bold text-[0.9rem]">Pre-Screening Form</span>
            <p className="flex gap-2">
              {!disabledAll ||
                queriesFields?.filter((op) => op.resolve == 0)?.length > 0 ? (
                <span className="flex gap-3" style={{ color: "#FB9D2C" }}>
                  <InfoIcon Height={20} Width={20} Filled="#FB9D2C" />
                  {"In-Progress"}
                </span>
              ) : (
                <span className="flex gap-3" style={{ color: "#00B278" }}>
                  <CheckGreen Filled="#00B278" />
                  {"Completed"}
                </span>
              )}{" "}
              {queriesFields?.filter((op) => op.resolve == 0)?.length > 0 && (
                <div className="flex gap-2">
                  {" "}
                  <div className="border-l-2 ">
                    <Typography
                      variant="body1"
                      className="ml-2 rounded-3xl text-center align-self-center  text-[0.8rem] w-[1.2rem] h-[1.2rem] text-[white] bg-[#FF0000]"
                    >
                      {queriesFields?.filter((op) => op.resolve == 0)?.length}
                    </Typography>
                  </div>
                  <span className="text-[red]">Query Raised</span>
                </div>
              )}
            </p>
          </Typography>
        )}
      </AccordionSummary>
      <AccordionDetails>
        <Divider />
        {isLoading ? (
          <SkeletonLoader rowCount={5} height={80} isTable={false} />
        ) : (
          <div>
           {patientData?.prescreen_form?.id && <PreScreenQueryHistory
              preScreenId={patientData?.prescreen_form?.id}
            />}

            <form className="!mt-2" onSubmit={formik.handleSubmit}>
              <Grid container spacing={2} className="mb-3">
                {formOptions?.map((props, key) => {
                  if (props.type === "custom-date-range") {
                    return (
                      <>
                          <Grid key={'_custom_date_'+key} item xs={12}>
                              <FormControl fullWidth className="pl-3 pr-3">
                                  {props.label && (
                                    <span
                                      className={`mb-1 text-base`}
                                    >
                                      {props.label}
                                    </span>
                                  )}
                                  <FormField
                                    value={props.displayValue}
                                    placeholder={props.placeholder}
                                    onClick={props.disabled ? undefined : props.onOpenModal} // Prevent click when disabled
                                    disabled={props.disabled}
                                    className="border"
                                    InputProps={{
                                      readOnly: true,
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <IconButton
                                            onClick={props.disabled ? undefined : props.onOpenModal} // Prevent click when disabled
                                            disabled={props.disabled}
                                            edge="end"
                                            className="pr-8 pl-10"
                                            sx={{
                                              // Ensure disabled state is visually clear
                                              '&.Mui-disabled': {
                                                color: 'text.disabled',
                                                backgroundColor: 'transparent'
                                              }
                                            }}
                                          >
                                            <CalendarTodayIcon fontSize="small" />
                                          </IconButton>
                                        </InputAdornment>
                                      ),
                                      ...props.InputProps,
                                    }}
                                  
                                  />
                                
                              </FormControl>
                                  {/* Error message */}
                              {(formik?.errors?.apheresisDateRange?.startDate || formik?.errors?.apheresisDateRange?.endDate) ? (
                                <span className={`input_error ml-3`}>
                                  {formik?.errors?.apheresisDateRange?.startDate}
                                </span>) :''}
                              </Grid>
                                <div className={'col-12'}>
                         
                                  {formik?.values?.preferred_date?.length > 0 && 
                                    <div className="w-full flex gap-2 text-[#5c5959]-300 text-sm pt-2"><Typography variant="div" className="text-[#5c5959]-300 pl-3"><span className="text-[#5c5959]-300">Preferred Apheresis Dates:</span></Typography>
                                     {Array.isArray(formik?.values?.preferred_date) &&
                                  formik.values.preferred_date.map((date, index) => {
                                    const showEdit = secheduleShow && !disabledAll;
                                    const isLast = index === formik.values.preferred_date.length - 1;

                                    return (
                                      <div key={index} className="flex gap-2">
                                        <Typography variant="span" className="text-[#5c5959]">
                                          {date}
                                        </Typography>

                                        {/* Show | only when EDIT button is visible AND not the last item */}
                                        {(!isLast || showEdit) && (
                                          <Typography variant="span" className="text-base text-[#5c5959]">
                                            |
                                          </Typography>
                                        )}
                                      </div>
                                    );
                                  })}
                                    {(!disabledAll || secheduleShow) ? <span
                                    onClick={() => { setDatePeferredModalOpen(true); setDateRangeModalOpen(false) }}
                                    className="cursor-pointer flex gap-2"
                                    disabled={props.disabled}
                                  >
                                    <EditIcon />Edit
                                  </span>:''}
                                  </div>
                                  }
                                   </div>
                    </>
                          
                                         );
                  }else{
                  // Skip rendering if the field has a depend condition that's not met
                  if (props.depend) {
                    const dependVal = formik?.values[props.depend];
                    const dependValues = props.dependValue.includes(",")
                      ? props.dependValue.split(",")?.map((v) => v.trim())
                      : [props.dependValue];

                    if (!dependValues.includes(`${dependVal}`)) {
                      return null;
                    }
                  }

                  if (props.section) {
                    return (
                      <Grid key={'_section_'+key} item xs={12} className="">
                        {/* Rest of your field rendering code */}
                        {props.section && (
                          <strong className="!pb-3">{props.section}</strong>
                        )}
                      </Grid>
                    );
                  }
                  return !props.manualField ? (
                    <Grid
                      key={'_manual_'+key}
                      item
                      xs={props.col && !props.children ? 12 / props.col : 12}
                    >
                      {/* Rest of your field rendering code */}
                      {props.section && (
                        <strong className="!pb-3">{props.section}</strong>
                      )}
                      <FormControl
                        variant={props.variant ?? "standard"}
                        fullWidth={props.fullWidth ?? true}
                        className={`pl-3 pr-3 ${props.section ? "pt-3" : ""} ${props.className ?? ""
                          }`}
                      >
                        {/* Field labels */}
                        {props.label && props.children && (
                          <FormLabel
                            shrink
                            required={props.required}
                            className="text-[black]"
                          >
                            {props.label}
                          </FormLabel>
                        )}
                        {props.subLabel && (
                          <Typography
                            variant="span"
                            className="text-[#828282] text-[0.7rem]"
                          >
                            {props.subLabel}
                          </Typography>
                        )}
                        <Typography
                        variant="span"
                        className={`z-[1] font-semibold absolute right-5 ${formik.errors[props.name] && formik.touched[props.name]
                            ? 'bottom-9'   // move higher when error shows
                            : 'bottom-4'   // default position
                            } text-[0.7rem]`}
                    >
                        {props.subLable === "power" ? (
                            <p>
                                x10<sup>6</sup>{props?.extraLabel ? props?.extraLabel : ' Cells'}
                            </p>
                        ) : (
                            <span className="text-sm pr-1">{props.subLable}</span>
                        )}
                    </Typography>

                        {/* Fields */}
                        {!props.manualValues &&
                          !props.isObj &&
                          (() => {
                            const value = checkPreScreenForm[props.name];
                            let questionInfo = queriesFields?.find(
                              (op) =>
                                op.fields === props.name
                            );
                             if(!questionInfo){
                               questionInfo = queriesFields?.find(
                              (op) =>
                                op.fields == props.depend
                            );
                               }
                            return (
                              <div className="relative">
                                <FormikControl
                                  formik={formik}
                                  {...props}
                                disabled={
                                    questionInfo?.resolve == 0 && ( role_id == 5 || role_slug === "project-manager")
                                      ? false
                                      : ( role_id != 5 &&role_slug != "project-manager") 
                                      ? true
                                      : props.disabled
                                  }
                                  className="mt-2"
                                />
                                {!props.noQuery &&
                                  (questionInfo?.resolve == 0 || (typeof value === "number"
                                    ? value === 0 || value !== ""
                                    : value !== "")) &&
                                  disabledAll &&
                                  props.type != "file" ? (
                                  <i
                                    onClick={(e) =>
                                      handleQuestionClick(
                                        e,
                                        props,
                                        questionInfo
                                      )
                                    }
                                    style={
                                      questionInfo?.resolve == 0 &&
                                        questionInfo.fields == props.name
                                        ? { color: "red" }
                                        : {}
                                    }
                                    className={`fas fa-question-circle circle-icon cursor-pointer z-50 absolute right-2 ${!props.label && props.type != "radio"
                                        ? "bottom-[3rem]"
                                        : props.type == "radio"
                                          ? "top-[2rem]"
                                          : "top-[0.6rem]"
                                      }`}
                                    aria-hidden="true"
                                  />
                                ) : (
                                  ""
                                )}
                              </div>
                            );
                          })()}

                        {/* Children Fields */}
                        {props.children &&
                          (props.isObj ? (
                            <div className="flex gap-3">
                              {props.children?.map(
                                (subFieldProps, subFieldPropsIndex) => {
                                  const questionInfo = queriesFields?.find(
                                    (op) => op.fields === subFieldProps.name
                                  );
                                  return (
                                    <div
                                      key={subFieldPropsIndex}
                                      className="w-full relative"
                                    >
                                      <FormikControl
                                        formik={formik}
                                        {...subFieldProps}
                                        disabled={
                                    questionInfo?.resolve == 0 && ( role_id == 5 || role_slug === "project-manager")
                                      ? false
                                      : ( role_id != 5 && role_slug != "project-manager") 
                                      ? true
                                      : props.disabled
                                  }
                                      />
                                      {!subFieldProps.noQuery &&
                                        disabledAll && (
                                          <i
                                            onClick={(e) =>
                                              handleQuestionClick(
                                                e,
                                                subFieldProps,
                                                questionInfo
                                              )
                                            }
                                            style={
                                              questionInfo?.resolve == 0
                                                ? { color: "red" }
                                                : {}
                                            }
                                            className="fas fa-question-circle circle-icon cursor-pointer z-50 absolute top-[0.3rem] right-2"
                                            aria-hidden="true"
                                          ></i>
                                        )}
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          ) : (
                            <FormikArrayPreScreen
                              handleQuestionClick={handleQuestionClick}
                              props={props}
                              formik={formik}
                              disabledAll={disabledAll}
                              buttonPermission={isEditorPM}
                              queriesFields={queriesFields}
                            />
                          ))}
                      </FormControl>
                    </Grid>
                  ) : (
                    <Grid
                      key={'_grid_'+key}
                      item
                      xs={12}
                      className="flex align-items-baseline"
                    ></Grid>
                  );
                }
                })}
              </Grid>
              <Grid container spacing={2}>
                {(isEditorPM || (secheduleShow && role_id == 1)) && (
                  <Grid item xs={12} className="flex justify-center gap-3 mb-2">
                    {(!disabledAll || secheduleShow) && (
                      <LoadingButton
                        loading={isLoading}
                        type="submit"
                        disabled={!secheduleShow && disabledAll}
                        variant="contained"
                        onClick={() => setIsDraft(false)}
                      >
                        Submit
                      </LoadingButton>
                    )}
                    {!secheduleShow && !disabledAll && <LoadingButton
                          type="submit"
                          variant="contained"
                          disabled={!secheduleShow && disabledAll}
                          onClick={() => setIsDraft(true)}
                          className="bg-[#ffa500]"
                        >
                          Save as Draft
                        </LoadingButton>}
                  </Grid>
                )}
              </Grid>
            </form>
            <PreScreenComment
              formValues={formik?.values}
              checkPreScreenForm={checkPreScreenForm}
              handleManualFormikValidaction={handleManualFormikValidaction}
              handleMenuClose={handleMenuClose}
              open={open}
              anchorEl={anchorEl}
              selectedField={selectedField}
              queryData={queryData}
              getPrimaryDiagnosis={getPrimaryDiagnosis}
            />
          </div>
        )}
      </AccordionDetails>
      <DeleteModal
        open={deleteModal}
        setClose={setDeleteModal}
        title={"Are you sure you want to Delete File ?"}
        buttonText={"Delete"}
        handleSuccess={hanldeRemoveFiles}
      />
         <DateRangePickerModal
              open={dateRangeModalOpen || datePeferredModalOpen}
              type={dateRangeModalOpen ? 'date': datePeferredModalOpen ? 'apheresis':''}
              onClose={() =>{setDatePeferredModalOpen(false); setDateRangeModalOpen(false)}}
              onApply={handleDateRangeApply}
              value={formik?.values?.apheresisDateRange}
              minDate={moment().startOf("day").toDate()}
              maxDate={moment().add(1, "year").endOf("day").toDate()}
            />
    </Accordion>
  );
};

export default PreScreenForm;
